module.exports = __webpack_public_path__ + "sh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sh.svg
// module id = 1055
// module chunks = 0